import React from 'react';
import PropTypes from 'prop-types';

import { getFormattedDateTime } from '../../../helpers/DateTime';

const AcceptedTermsOfServiceListItem = ({ element }) => (
  <tr>
    <td>
      {element.ip_address ? element.ip_address : '-'}
    </td>
    <td>
      {element.created_at ? getFormattedDateTime(element.created_at) : '-'}
    </td>
  </tr>
);

AcceptedTermsOfServiceListItem.propTypes = {
  element: PropTypes.object.isRequired,
};

export default AcceptedTermsOfServiceListItem;
